<template>
  <div class="md-layout px-0 pb-5" v-if="form">
    <div
      v-for="(item, index) in form"
      :key="'info' + index"
      class="md-layout-item md-size-33 md-medium-size-50 px-0 pt-6"
    >
      <md-icon>{{ item.icon }}</md-icon>
      {{ $t(item.name) }}: {{ $t(item.value) }}
      {{
        item.name === "zoom_meeting.duration" ? $t("zoom_meeting.minutes") : ""
      }}
    </div>
  </div>
</template>
<script>
import moment from "moment";
const clientLocale = localStorage.getItem("language");
const formatDateClient =
  clientLocale === "en" ? "MM-DD-YYYY hh:mm A" : "DD-MM-YYYY hh:mm A";

import {
  scheduleMeetingList,
  recurringMeetingList
} from "../../Components/ultils";
import cloneDeep from "lodash/cloneDeep";
export default {
  props: ["data"],
  data() {
    return {
      form: null
    };
  },
  watch: {
    data: function(newVal) {
      if (!newVal) return;
      this.form = this.setListGeneralInfo(cloneDeep(newVal));
    }
  },
  methods: {
    setListGeneralInfo(formProps) {
      const meetingType = formProps.zoom_meeting_type;
      let dateTime = formProps.start + " " + formProps.from_time;
      let startDateTime = moment(dateTime).format(formatDateClient);
      formProps.startDateTime = startDateTime;
      if (meetingType === "A schedule meeting") {
        return scheduleMeetingList(formProps);
      }
      return recurringMeetingList(formProps);
    }
  }
};
</script>
